import { create } from "zustand";
import type { TenantUsageData } from "@/domain/types";
import { getTenantUsage } from "@/infrastructure/tenant-usage/tenantUsageService";

interface TenantUsageState {
  data: TenantUsageData | null;
  loading: boolean;
  error: boolean;
  fetch: () => Promise<void>;
  refresh: () => Promise<void>;
}

export const useTenantUsageStore = create<TenantUsageState>((set, get) => ({
  data: null,
  loading: false,
  error: false,
  fetch: async () => {
    if (get().data || get().loading) return; // already loaded or loading
    set({ loading: true, error: false });
    try {
      const data = await getTenantUsage();
      set({ data, loading: false });
    } catch {
      set({ loading: false, error: true });
    }
  },
  refresh: async () => {
    set({ loading: !get().data, error: false });
    try {
      const data = await getTenantUsage();
      set({ data, loading: false });
    } catch {
      set({ loading: false, error: !get().data });
    }
  },
}));
